import React, { useState, useEffect } from "react";
import { navLinks, profile } from "@/lib/data";
import { Download } from "lucide-react";

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="nav-container"
            className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
                scrolled
                    ? "bg-black/80 backdrop-blur-xl border-b border-term-green/20"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    className="font-mono text-sm tracking-tight text-ink-primary hover:text-term-green transition-colors"
                >
                    <span className="text-term-green">MS</span>
                    <span className="text-ink-tertiary">://</span>
                    <span className="text-ink-secondary">portfolio</span>
                    <span className="cursor-blink text-term-green">_</span>
                </a>

                <nav className="hidden md:flex items-center gap-1">
                    {navLinks.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label}`}
                            className="group px-3 py-2 text-xs font-mono uppercase tracking-[0.18em] text-ink-secondary hover:text-term-green transition-colors"
                        >
                            <span className="text-ink-tertiary group-hover:text-term-green">
                                $
                            </span>{" "}
                            {l.label}
                        </a>
                    ))}
                    <a
                        href={profile.resumeUrl}
                        download
                        data-testid="nav-resume-download"
                        className="ml-3 inline-flex items-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-[0.18em] border border-term-green/40 text-term-green hover:bg-term-green hover:text-bg-base transition-colors"
                    >
                        <Download className="w-3.5 h-3.5" />
                        resume.pdf
                    </a>
                </nav>

                <button
                    data-testid="nav-mobile-toggle"
                    aria-label="Toggle menu"
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden text-term-green font-mono text-xs border border-term-green/40 px-3 py-2"
                >
                    {open ? "[ close ]" : "[ menu ]"}
                </button>
            </div>

            {open && (
                <div
                    data-testid="nav-mobile-panel"
                    className="md:hidden bg-black/95 border-t border-term-green/20 px-6 py-6 space-y-3"
                >
                    {navLinks.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={() => setOpen(false)}
                            data-testid={`nav-mobile-link-${l.label}`}
                            className="block font-mono text-sm uppercase tracking-[0.18em] text-ink-secondary hover:text-term-green"
                        >
                            <span className="text-term-green">$</span> {l.label}
                        </a>
                    ))}
                    <a
                        href={profile.resumeUrl}
                        download
                        data-testid="nav-mobile-resume-download"
                        className="inline-flex items-center gap-2 mt-2 px-3 py-2 text-xs font-mono uppercase tracking-[0.18em] border border-term-green/40 text-term-green"
                    >
                        <Download className="w-3.5 h-3.5" /> resume.pdf
                    </a>
                </div>
            )}
        </header>
    );
}
